import { useLayoutEffect, useRef } from 'react';
import { gsap, revealUp, prefersReducedMotion } from '../lib/motion';

export default function Statement() {
  const ref = useRef<HTMLElement>(null);
  const bgRef = useRef<HTMLDivElement>(null);

  useLayoutEffect(() => {
    const el = ref.current;
    if (!el) return;
    const ctx = gsap.context(() => {
      revealUp('.stmt-reveal', el);
      if (!prefersReducedMotion() && bgRef.current) {
        gsap.fromTo(
          bgRef.current,
          { yPercent: -10, scale: 1.15 },
          {
            yPercent: 10,
            scale: 1.15,
            ease: 'none',
            scrollTrigger: { trigger: el, start: 'top bottom', end: 'bottom top', scrub: true },
          }
        );
      }
    }, el);
    return () => ctx.revert();
  }, []);

  return (
    <section ref={ref} className="relative overflow-hidden vignette">
      <div
        ref={bgRef}
        className="absolute inset-0 bg-cover bg-center will-change-transform"
        style={{ backgroundImage: 'url("/images/noir-dusk.jpg")' }}
      />
      <div className="absolute inset-0 bg-ink-950/55" />

      <div className="relative z-10 mx-auto flex min-h-[85vh] max-w-4xl flex-col items-center justify-center px-6 py-32 text-center">
        <p className="stmt-reveal eyebrow mb-8">The Standard</p>
        <h2 className="stmt-reveal font-display text-5xl font-medium leading-[1.05] text-steel-100 md:text-7xl">
          Every project.
          <br />
          <span className="italic text-gold-300">One standard.</span>
        </h2>
        <div className="stmt-reveal mt-12 h-px w-24 bg-gold-500/60" />
        <p className="stmt-reveal mt-10 max-w-xl text-base font-light leading-relaxed text-steel-200 md:text-lg">
          Licensed. Insured. Delivered on time — from a single unit turn to a
          ground-up commercial build.
        </p>
      </div>
    </section>
  );
}
